interface DataSheet{
    useragent: string,
    timestamp: string,
    userid: number,
    orderid: number,
    pageview: string,
    gtm: string
}

export async function SendDataSubscribe(dataSheet: DataSheet) {
    var request = new XMLHttpRequest();
    request.open("POST", "https://script.google.com/macros/s/AKfycbzdWKE5n9TngNvj3ypwUn-jKebRJPxiva2dDGIZLHlqjebiiifxMs_oRV04ilujJmM/exec");
    request.setRequestHeader('Content-type', 'text/plain');
    
    var params = {
      "orderid": dataSheet.orderid,
      "userid": dataSheet.userid,
      "pageview": dataSheet.pageview,
      "timestamp": dataSheet.timestamp,
      "useragent": dataSheet.useragent,
      "gtm": dataSheet.gtm
    }
    
    request.send(JSON.stringify(params));
}